import { render } from "./ButtonWithSpecyficText.vue?vue&type=template&id=716847c1&scoped=true"
import script from "./ButtonWithSpecyficText.vue?vue&type=script&lang=js"
export * from "./ButtonWithSpecyficText.vue?vue&type=script&lang=js"

import "./ButtonWithSpecyficText.vue?vue&type=style&index=0&id=716847c1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716847c1"]])

export default __exports__